import { render, staticRenderFns } from "./QRDealerStock.vue?vue&type=template&id=552313cc"
import script from "./QRDealerStock.vue?vue&type=script&lang=js"
export * from "./QRDealerStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports